export default __webpack_public_path__ + "static/media/content_02_bg.ac49345b.jpg";